import { ReactNode } from "react";
import { useParams } from "react-router";

import useMeGetClientInfoQuery from "../api/useMeGetClientInfoQuery";
import ClientContext from "./ClientContext";

function ClientContextProvider({ clientSlug, children }: { clientSlug: string; children: ReactNode }) {
    const { data, loading, error } = useMeGetClientInfoQuery(clientSlug);

    return (
        <ClientContext.Provider
            value={{
                loading,
                error,
                client: data,
            }}
        >
            {children}
        </ClientContext.Provider>
    );
}

export default function ClientContextProviderWrapper({ children }: { children: ReactNode }) {
    const { clientSlug } = useParams();

    if (clientSlug) {
        return <ClientContextProvider clientSlug={clientSlug}>{children}</ClientContextProvider>;
    }
    return children;
}
